import React from 'react';

// Styles
import { Container } from './styles';

// Interface
interface Props {
  children: React.ReactNode;
  type: 'video' | 'text' | 'teacher';
}

export function BoxItem({ children, type }: Props) {
  return <Container type={type}>{children}</Container>;
}
